// timerPlugin.js
export default {
    install: (app) => {
        app.mixin({
            mounted() {
                const timers = document.querySelectorAll('.offer-timer');

                timers.forEach((el) => {
                    const id = el.id || 'main'; // ID важен, если таймеров будет несколько
                    const storageKey = `timer_end_${id}`;

                    let endTime = localStorage.getItem(storageKey);

                    if (!endTime) {
                        const seconds = parseInt(el.getAttribute('data-timer')) || 0;
                        endTime = Date.now() + seconds * 1000;
                        localStorage.setItem(storageKey, String(endTime));
                    } else {
                        endTime = parseInt( endTime );
                    }

                    el.innerHTML = `
                        <div class="t-group">
                            <div class="t-digits"><span class="t-num">0</span><span class="t-num">0</span></div>
                            <div class="t-label">HOURS</div>
                        </div>
                        <div class="t-sep">:</div>
                        <div class="t-group">
                            <div class="t-digits"><span class="t-num">0</span><span class="t-num">0</span></div>
                            <div class="t-label">MINUTES</div>
                        </div>
                        <div class="t-sep">:</div>
                        <div class="t-group">
                            <div class="t-digits"><span class="t-num">0</span><span class="t-num">0</span></div>
                            <div class="t-label">SECONDS</div>
                        </div>
                    `;

                    const allNums = el.querySelectorAll('.t-num');

                    const tick = () => {
                        let diff = Math.max(0, endTime - Date.now());

                        // Если время вышло
                        if (diff <= 0) {
                            const seconds = parseInt(el.getAttribute('data-timer')) || 0;
                            endTime = Date.now() + seconds * 1000;
                            localStorage.setItem(storageKey, String(endTime));
                            diff = seconds * 1000; // обновляем diff для текущего кадра
                        }

                        const h = Math.floor(diff / 3600000).toString().padStart(2, '0');
                        const m = Math.floor((diff % 3600000) / 60000).toString().padStart(2, '0');
                        const s = Math.floor((diff % 60000) / 1000).toString().padStart(2, '0');

                        const fullStr = h + m + s;

                        fullStr.split('').forEach((char, i) => {
                            if (allNums[i] && allNums[i].textContent !== char) {
                                allNums[i].textContent = char;
                            }
                        });
                    };

                    const interval = setInterval(tick, 1000);
                    tick();
                });
            }
        });
    }
};
